"use client";

import { Progress, ProgressColor } from "@workspace/ui/components";
import {
  Footer,
  FooterSkeleton,
  Navbar,
  NavbarSkeleton,
} from "@workspace/ui/widgets";
import { usePathname, useRouter } from "next/navigation";
import React, { Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

import { useCart, useCustomer, useGlobal } from "@/context";

// import { SimpleAuthForm } from "@/forms";
import Accessible from "../Accessible/Accessible";

const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  const [hideButton, setHideButton] = useState<boolean | null>(null);

  const {
    state: {
      menuItems,
      linkBlocks,
      loadingHomepage,
      authLoading,
      // isAuthenticated,
      popularSearches,
      matchingCategories,
      loadingPopularSearches,
    },
    getHomepageData,
    getPopularSearchesData,
    clearPopularSearchesData,
    clearGetResponseData,
  } = useGlobal();

  const {
    state: { customer, isLoggedIn, isLoadingAccountInfo },
    getAccountInfo,
    logout,
  } = useCustomer();

  const {
    state: { cart, loadingCart, loadingUpdateCart },
    getCart,
  } = useCart();

  useEffect(() => {
    getHomepageData().then(() => {
      getAccountInfo().then(() => {
        getCart();
      });
    });

    const hideButton = localStorage.getItem("carry-hide-button");
    if (hideButton === "true") {
      setHideButton(true);
    } else {
      setHideButton(false);
    }
  }, []);

  const router = useRouter();
  const pathname = usePathname();

  if (authLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Progress color={ProgressColor.GRAYSCALE_400} />
      </div>
    );
  }

  // if (!isAuthenticated) {
  //   return (
  //     <div className="flex justify-center items-center h-screen">
  //       <SimpleAuthForm />
  //     </div>
  //   );
  // }

  if (pathname === "/zamowienie") {
    return children;
  }

  return (
    <div className="grid grid-rows-[1fr_auto] min-h-screen">
      <main>
        <Suspense fallback={<NavbarSkeleton />}>
          <Navbar
            isLoggedIn={isLoggedIn}
            userName={customer?.firstname || ""}
            logout={() => {
              logout().then(() => {
                router.push("/");
                clearGetResponseData();
              });
            }}
            isLoadingAccount={isLoadingAccountInfo}
            isLoadingCart={loadingCart || loadingUpdateCart}
            cart={cart}
            isLoading={loadingHomepage}
            menuItems={menuItems}
            popularSearches={popularSearches}
            matchingCategories={matchingCategories}
            loadingPopularSearches={loadingPopularSearches}
            getPopularSearchesData={getPopularSearchesData}
            clearPopularSearchesData={clearPopularSearchesData}
          />
        </Suspense>

        <ToastContainer />

        <Accessible hideButton={hideButton} setHideButton={setHideButton} />

        {children}
      </main>

      <Suspense fallback={<FooterSkeleton />}>
        <Footer
          linkBlocks={linkBlocks || []}
          isLoading={loadingHomepage}
          isLoggedIn={isLoggedIn}
          setHideButton={setHideButton}
        />
      </Suspense>
    </div>
  );
};

export default AppWrapper;
